import { gsap } from 'gsap';

export default function() {
	const $html = $('html');
	const slide_start_interval = 1500; // 読み込み完了からスライダー開始までの時間
	const tm = new TimelineMax();

	function opAnim(set_num) {
		tm.to( '.mv_cover', 1, {
			delay: 0.6,
			width: '0%',
			ease: Power3.easeInOut
		})
		.add('s1')
		.staggerFromTo( '#mv_leads li', 0.8,
			{ x: '-10%'},
			{ x: '0%', opacity: 1, ease: Power0.ease }
			, 0.25, 's1 -= .15')
		.add('s2')
		.fromTo( '#mv_count', 0.6,
			{ x: '-5%'},
			{ x: '0%', opacity: 1, ease: Power0.ease }
			, 's2 -= .3')
		.to( '.scr_down', 0.6, {
	  	opacity: 1,
	  	ease: Power0.ease
		});
	}

	function slider(slideTgt, slide_itemTgt) {
		const slide = document.getElementById('mv_slider');
		const slide_item = slide.querySelectorAll('.mv_slide');
		const mv_count = document.getElementById('mv_count');
		const mv_count_item = mv_count.querySelectorAll('.count_item');
		const slide_total_num = slide_item.length - 1;
		const count_total_num = mv_count_item.length - 1;
		const fadeTime = 1500; // フェードの時間
		const viewTime = 4500; // 1枚の表示時間
		let slide_active_num = 0;
		let count_active_num = 0;
		let nowSlide;
		let nextSlide;
		let nowCount;
		let nextCount;
		const active_class = 'is-active';

		slide_item[0].classList.add(active_class);
		mv_count_item[0].classList.add(active_class);

		setInterval(() => {
			if (slide_active_num < slide_total_num && count_active_num < count_total_num) {
				nowSlide = slide_item[slide_active_num];
				nextSlide = slide_item[++slide_active_num];
				nowCount = mv_count_item[count_active_num];
				nextCount = mv_count_item[++count_active_num];
			} else {
				nowSlide = slide_item[slide_active_num];
				nextSlide = slide_item[slide_active_num = 0];
				nowCount = mv_count_item[count_active_num];
				nextCount = mv_count_item[count_active_num = 0];
			}

			nowSlide.classList.remove(active_class);
			nowCount.classList.remove(active_class);
			nextSlide.classList.add(active_class);
			nextCount.classList.add(active_class);

			setTimeout(() => {
				nowSlide.classList.remove(active_class);
				nowCount.classList.remove(active_class);
			}, fadeTime);
		}, viewTime);
	}

	$(window).on('load', function() {

		var ww = window.innerWidth;
		var set_num = 36;

		if(ww > 750){
			set_num = 23;
		}

		opAnim(set_num);

		setTimeout(() => {
			$html.addClass('slider-start');
			slider();
		}, slide_start_interval);
	});

}
